<template>
  <v-card style="height: 100%">
    <div class="card-body">
      <v-responsive :aspect-ratio="1">
        <div
          style="
            background-color: #eee;
            height: 100%;
            background-position: center;
            background-size: cover;
          "
          :style="{
            backgroundImage:
              'url(\'' +
              productImages[0] +
              '\'),url(\'/static/img/assets/_global/default-photo.png\')'
          }"
        ></div>
      </v-responsive>
      <template>
        <div style="position: relative">
          <div class="action" style="position: absolute; top: -20px; left: 0; right: 0px"></div>
          <div style="padding: 15px; border-bottom: 1px solid #eee">
            <div class="name" :title="product.product_title">
              {{ product.product_title | truncate(50) }}
            </div>
            <div>
              <div>
                SKU:<span class="primary--text"> {{ product.sku }}</span>
              </div>
              <div>
                Sale:<span class="primary--text">{{ product.product_sale_net }}</span>
              </div>
              <div>
                Price:<span class="primary--text">{{ product.product_price }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </v-card>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import ModalEditProduct from './ModalEditProduct'
import ModalShareLink from './ModalShareLink'
import StockItem from './StockItem.vue'

export default {
  props: ['value', 'category', 'selectCategory'],
  data: function () {
    return {
      product: this.value,
      showModal: false,
      showLink: false,
      status: !this.value.hiddenstatus
    }
  },
  components: {
    ModalEditProduct,
    StockItem,
    ModalShareLink
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    productImages: function () {
      if (this.product.product_thumb) {
        return this.product.product_thumb.split(';;')
      } else if (this.product.product_thumb) {
        return this.product.product_thumb.split(';;')
      } else {
        return ''
      }
    },
    currencySign: function () {
      return '฿'
    }
  },
  methods: {
    toggleProductStatus(product) {
      let vm = this
      let objProduct = { ...product }
      var status = this.status

      Object.assign(objProduct, { hiddenstatus: !status })

      return new Promise((resolve, reject) => {
        api.editProductKFC(
          {
            ...objProduct
          },
          function (error, response) {
            if (error) reject(error)

            resolve(response)
          }
        )
      })
    },
    close: async function () {
      let vm = this
      vm.showModal = false

      await vm.$nextTick()
      vm.$emit('input', vm.product)
    },
    onDeleteProduct: function (id) {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.product.name.replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            vm.$store.dispatch('loading')
            api.deleteProduct(id, function (error, response) {
              if (error) {
                vm.$store.dispatch('loading')
                console.error(error)
                return
              }

              vm.$emit('productDeleted')
              vm.$emit('close')
              vm.$store.dispatch('loading')
            })
          }
        })
    },
    isProductActive: function (hiddenstatus) {
      if (hiddenstatus) {
        return false
      } else {
        return 'checked'
      }
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.product = this.value
      }
    },
    showModal: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ProductThailandpostmart.vue